module.exports = {
	"googleMaps": "AIzaSyAxZYkiZ0uG9UFtBLFMWLeakspCerE88W8",
	"gaTrackerId": "UA-35318351-1"
};


//////////////////
// WEBPACK FOOTER
// ../keys/keys.json
// module id = 22
// module chunks = 0